<template>
  <div v-if="success">
    <b-alert show variant="success" class="text-center">
      <slot/>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    success: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

div {
  margin: $spacing-md 0
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/form-success.vue